<template>
  <v-app-bar
    hide-on-scroll
    elevate-on-scroll
    scroll-threshold="100"
    color="white"
    height="90px"
    app
  >
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="66px"
          />
        </router-link>

        <div class="d-flex align-center">
          <div>
            <div
              v-for="({ text, to, dropdown }, keyMenu) in menu"
              :key="keyMenu"
              class="d-inline-flex"
            >
              <v-btn
                v-if="!dropdown"
                class="text-none px-2 px-lg-3 py-5 nav-link"
                :to="to"
                active-class="nav-link-active"
                rounded
                depressed
                text
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="text-none px-2 px-lg-3 py-5 nav-link"
                    active-class="nav-link-active"
                    tile
                    depressed
                    text
                  >
                    {{ text }}
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    :to="item.to"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>

        <ButtonWidget to="/atendimento">Canais de Atendimento</ButtonWidget>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { menu } from "../../../config";
import ButtonWidget from "../../widgets/ButtonWidget.vue";

export default {
  data: () => ({
    menu,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  components: { ButtonWidget },
};
</script>

<style lang="scss">
.nav-link {
  font-size: 16px !important;
}
.nav-link.nav-link-active {
  color: var(--v-primary-base);
}
.nav-link.nav-link-active::before,
.nav-link:active {
  background: none;
}
</style>
